<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)">
</app-ship-details>

<div *ngIf="shipsContact">
  <div class="card card-nc" *ngIf="hasEntitlement('SHIPS_CONTACTS_DISBO')">
    <div class="card-heading">
      <span class="icon-NC_contact"></span>
      <span class="cardHeaderHeading"> Disbursing Office </span>
      <span class="pull-right save-panel">
        <span [class]="stripDOSuccessFail">
          <span [class]="stripDOCircle">
          </span>&nbsp;&nbsp;{{stripDOStatus}}
        </span>
        &nbsp;
        <button
          type="submit"
          *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
          [disabled]="save_do_btn"
          (click)="saveShipsContact()"
          class="btn btn-nc">
          SAVE <i [class]="save_do_btn_spinner"></i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <form name="disboForm" [formGroup]="disboForm">
        <div class="row">
          <div class="col-md-4">
            <label for="disboName" class="col-md-12 control-label labelCommon"> Officer </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              <input type="text"
                     class="form-control input-sm"
                     id="disboName"
                     formControlName="officer"
                     maxlength="50"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!disboForm.get('officer').valid &&
                            disboForm.get('officer').touched &&
                            disboForm.get('officer').errors['invalidDisboName']">
                  Enter a valid disboName.
                </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              {{shipsContact.disboName}}
            </div>
          </div>
          <div class="col-md-4">
            <label for="disboPhone" class="col-md-12 control-label labelCommon"> Phone </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              <input
                type="text"
                class="form-control input-sm"
                id="disboPhone"
                formControlName="phone"
                maxlength="50"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!disboForm.get('phone').valid &&
                          disboForm.get('phone').touched &&
                          disboForm.get('phone').errors['invalidPhone']">
                Enter a valid disbo Phone.
              </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              {{shipsContact.disboPhone}}
            </div>
          </div>
          <div class="col-md-4">
            <label for="disboEmail" class="col-md-12 control-label labelCommon"> Email </label>
            <div class="form-group col-md-12" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              <input
                type="text"
                class="form-control input-sm"
                id="disboEmail"
                formControlName="email"
                maxlength="50"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!disboForm.get('email').valid &&
                          disboForm.get('email').touched &&
                          disboForm.get('email').errors?.email">
                Enter a valid disbo Email.
              </span>
            </div>
            <div class="form-group col-md-12 staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              {{shipsContact.disboEmail}}
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="shipsContact">
  <div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW')">
    <div class="card-heading">
      <span class="icon-NC_contact"></span>
      <span class="cardHeaderHeading"> LSR Contact </span>
      <span class="pull-right save-panel">
        <span [class]="stripLSRSuccessFail">
          <span [class]="stripLSRCircle">
          </span>&nbsp;&nbsp;{{stripLSRStatus}}
        </span>&nbsp;
        <button
          type="submit"
          *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
          [disabled]="save_lsr_btn"
          (click)="saveLSRContact()"
          class="btn btn-nc">
          SAVE <i [class]="save_lsr_btn_spinner"></i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <form name="lsrForm" [formGroup]="lsrForm">
        <div class="row" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="col-md-4">
            <label for="lsrContact" class="col-md-12 control-label labelCommon"> Contact </label>
            <div class="form-group col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="lsrContact"
                formControlName="contact"
                maxlength="100"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!lsrForm.get('contact').valid &&
                          lsrForm.get('contact').touched &&
                          lsrForm.get('contact').errors['invalidLsrContact']">
                Enter a valid Lsr Contact.
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label for="lsrPhone" class="col-md-12 control-label labelCommon"> Phone </label>
            <div class="form-group col-md-12">
              <input
                type="text"
                class="form-control input-sm"
                id="lsrPhone"
                formControlName="phone"
                maxlength="50"/>
              <span class="help-block has-error validationMessage"
                    *ngIf="!lsrForm.get('phone').valid &&
                          lsrForm.get('phone').touched &&
                          lsrForm.get('phone').errors['invalidPhone']">
                Enter a valid Lsr Phone.
              </span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="col-md-4">
            <label for="lsrContact" class="col-md-12 control-label labelCommon"> Contact </label>
            <div class="form-group col-md-12 staticText1">
              {{shipsContact.lsrContact}}
            </div>
          </div>
          <div class="col-md-4">
            <label for="lsrPhone" class="col-md-12 control-label labelCommon"> Phone </label>
            <div class="form-group col-md-12 staticText1">
              {{shipsContact.lsrPhone}}
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="shipsContact">
  <div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW')">
    <div class="card-heading">
      <i class="fa fa-home"></i>
      <span class="cardHeaderHeading"> Ship Address </span>
      <span class="pull-right save-panel">
        <span [class]="stripBASuccessFail">
          <span [class]="stripBACircle"></span>&nbsp;&nbsp;{{stripBAStatus}}
        </span>&nbsp;
        <button
          type="submit"
          *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
          [disabled]="save_ba_btn"
          (click)="saveShipAddress()" class="btn btn-nc">
          SAVE <i [class]="save_ba_btn_spinner"></i>
        </button>
      </span>
    </div>
    <div class="card-body">
      <form name="shipAddressForm" [formGroup]="shipAddressForm">
        <div class="row">
          <div class="form-group col-md-12" style="margin-bottom: 15px;">
            <span class="labelCommon">The ship address is used for open loop purchases with PNC.</span>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12" style="margin-bottom: 15px;">
            <span class="labelCommon">*Address</span><br>
            <input
              *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
              type="text"
              class="form-control input-sm"
              id="addressLine1"
              formControlName="addressLine1"
              maxlength="34"/>
              <span
              *ngIf="!shipAddressForm.get('addressLine1').valid &&
                shipAddressForm.get('addressLine1').touched"
              class="help-block has-error validationMessage">
                <span *ngIf="shipAddressForm.get('addressLine1').errors['required']">
                  Required
                </span>
              </span>
            <span class="staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
              <div *ngIf="shipsContact.address">
                {{shipsContact.address.addressLine1}}
              </div>
            </span>
          </div>
        </div>
        <div class="row" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-6" style="margin-bottom: 15px;">
            <input
              type="text"
              class="form-control input-sm"
              id="addressLine2"
              formControlName="addressLine2"
              maxlength="34"/>
            <span
              *ngIf="shipAddressForm.get('addressLine2').errors &&
                !shipAddressForm.get('addressLine2').errors['required'] &&
                !shipAddressForm.get('addressLine2').valid &&
                shipAddressForm.get('addressLine2').touched"
              class="help-block has-error validationMessage">
              Please enter a valid Address - only numbers, alpha characters, spaces and dashes are allowed
            </span>
          </div>
          <div class="form-group col-md-6" style="margin-bottom: 15px;">
            <input
              type="text"
              class="form-control input-sm"
              id="addressLine3"
              formControlName="addressLine3"
              maxlength="34"/>
            <span
              *ngIf="shipAddressForm.get('addressLine3').errors &&
                !shipAddressForm.get('addressLine3').errors['required'] &&
                !shipAddressForm.get('addressLine3').valid &&
                shipAddressForm.get('addressLine3').touched"
              class="help-block has-error validationMessage">
              Please enter a valid Address - only numbers, alpha characters, spaces and dashes are allowed
            </span>
          </div>
        </div>
        <div class="row" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-6 staticText1" style="margin-bottom: 15px;">
            <div *ngIf="shipsContact.address">
              {{shipsContact.address.addressLine2}}
            </div>
          </div>
          <div class="form-group col-md-6 staticText1" style="margin-bottom: 15px;">
            <div *ngIf="shipsContact.address">
              {{shipsContact.address.addressLine3}}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-4">
            <span class="labelCommon">*City</span><br>
            <input
              type="text"
              class="form-control input-sm"
              id="city"
              formControlName="city"
              maxlength="34"/>
            <span id="spanCity"
              *ngIf="shipAddressForm.get('city').touched &&
                shipAddressForm.get('city').errors &&
                shipAddressForm.get('city').errors['required']"
              class="help-block has-error validationMessage">
              Required
            </span>
            <span
              *ngIf="shipAddressForm.get('city').errors &&
                !shipAddressForm.get('city').errors['required'] &&
                !shipAddressForm.get('city').valid &&
                shipAddressForm.get('city').touched"
              class="help-block has-error validationMessage">
              Please enter a valid City name - only alpha characters, spaces and dashes are allowed
            </span>
          </div>
          <div class="form-group col-md-4">
            <span class="labelCommon">*State</span><br>
            <select
              class="form-control input-sm"
              id="state"
              formControlName="state">
              <option *ngFor="let state of shipsContact.states" [value]="state">{{state}}</option>
            </select>
            <span *ngIf="!shipAddressForm.get('state').valid &&
                          shipAddressForm.get('state').touched &&
                          shipAddressForm.get('state').errors['required']"
                  class="help-block has-error validationMessage">
                   Required
            </span>
          </div>
          <div class="form-group col-md-4">
            <span class="labelCommon">*Zip</span><br>
            <input
              type="text"
              class="form-control input-sm"
              id="zip"
              formControlName="zip"
              name="zip"
              maxlength="10"/>
            <span *ngIf="!shipAddressForm.get('zip').valid &&
                          shipAddressForm.get('zip').touched"
                  class="help-block has-error validationMessage">
              <span *ngIf="shipAddressForm.get('zip').errors['required']">
                   Required
            </span>
              <span *ngIf="shipAddressForm.get('zip').errors['pattern']">
                Please enter a valid Zip - only numbers are allowed
              </span>
            </span>
          </div>
        </div>
        <div class="row" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-4">
            <span class="labelCommon">*City</span><br><span class="staticText1">
              <div *ngIf="shipsContact.address">
                {{shipsContact.address.city}}
              </div>
            </span>
          </div>
          <div class="form-group col-md-4">
            <span class="labelCommon">*State</span><br><span class="staticText1">
              <div *ngIf="shipsContact.address">
                {{shipsContact.address.state}}
              </div>
            </span>
          </div>
          <div class="form-group col-md-4">
            <span class="labelCommon">*Zip</span><br><span class="staticText1">
              <div *ngIf="shipsContact.address">
                {{shipsContact.address.zip}}
              </div>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="shipsContact">
  <div class="card card-nc" *ngIf="hasEntitlement('SHIPS_ROUNDTRIPS_OVERVIEW')">
    <div class="card-heading">
      <i class="fa fa-home"></i>
      <span class="cardHeaderHeading"> Bulk Mailing Address </span>
      <span class="pull-right save-panel">
      <span [class]="stripEBASuccessFail">
        <span [class]="stripEBACircle"></span>&nbsp;&nbsp;{{stripEBAStatus}}
      </span>&nbsp;
      <button
        type="submit"
        *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
        [disabled]="save_eba_btn"
        (click)="saveBulkAddress()" class="btn btn-nc">
        SAVE <i [class]="save_eba_btn_spinner"></i>
      </button>
    </span>
    </div>
    <div class="card-body">
      <form name="bulkAddressForm" [formGroup]="bulkAddressForm">
        <div class="row">
          <div class="form-group col-md-12" style="margin-bottom: 15px;">
            <span class="labelCommon">The bulk mailing address is used on the Fedex or USPS mailing label to deliver bulk card orders to NAVSUP.</span>
          </div>
        </div>
        <!-- EMV ContactName -->
        <div class="row">
          <div class="form-group col-md-6" style="margin-bottom: 15px;">
            <span class="labelCommon">*Contact Name</span><br>
            <input
              *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
              type="text"
              class="form-control input-sm"
              id="contactName"
              formControlName="contactName"
              maxlength="50"/>
            <span
              *ngIf="!bulkAddressForm.get('contactName').valid &&
                bulkAddressForm.get('contactName').touched &&
                bulkAddressForm.get('contactName').errors['required']"
              class="help-block has-error validationMessage">
              Required
            </span>
            <span class="staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
                {{shipsContact.emvBulkAddress.bulkContactName}}
              </span>
          </div>
          <!-- EMV Company -->
          <div class="form-group col-md-6" style="margin-bottom: 15px;">
            <span class="labelCommon">Company</span><br>
            <input
              *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
              type="text"
              class="form-control input-sm"
              id="company"
              formControlName="company"
              maxlength="30"/>
            <span class="staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
                {{shipsContact.emvBulkAddress.bulkCompany}}
              </span>
          </div>
        </div>
        <!-- EMV AddressLine1 -->
        <div class="row">
          <div class="form-group col-md-12" style="margin-bottom: 15px;">
            <span class="labelCommon">*Address</span><br>
            <input
              *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')"
              type="text"
              class="form-control input-sm"
              id="emvAddressLine1"
              formControlName="addressLine1"
              maxlength="34"/>
            <span
              *ngIf="!bulkAddressForm.get('addressLine1').valid &&
                bulkAddressForm.get('addressLine1').touched"
              class="help-block has-error validationMessage">
              <span *ngIf="bulkAddressForm.get('addressLine1').errors['required']">
              Required
            </span>
            <span
              *ngIf="bulkAddressForm.get('addressLine1').errors &&
                  !bulkAddressForm.get('addressLine1').errors['required']">
              Please enter a valid Address - only numbers, alpha characters, spaces and dashes are allowed
            </span>
            </span>
            <span class="staticText1" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')"> {{shipsContact.emvBulkAddress.addressLine1}}
            </span>
          </div>
        </div>
        <!-- EMV AddressLine2/AddressLine3 -->
        <div class="row" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-6" style="margin-bottom: 15px;">
            <input
              type="text"
              class="form-control input-sm"
              id="emvAddressLine2"
              formControlName="addressLine2"
              maxlength="34"/>
            <span
              *ngIf="bulkAddressForm.get('addressLine2').errors &&
                !bulkAddressForm.get('addressLine2').errors['required'] &&
                !bulkAddressForm.get('addressLine2').valid &&
                bulkAddressForm.get('addressLine2').touched"
              class="help-block has-error validationMessage">
              Please enter a valid Address - only numbers, alpha characters, spaces and dashes are allowed
            </span>
          </div>
          <div class="form-group col-md-6" style="margin-bottom: 15px;">
            <input
              type="text"
              class="form-control input-sm"
              id="emvAddressLine3"
              formControlName="addressLine3"
              maxlength="34"/>
            <span
              *ngIf="bulkAddressForm.get('addressLine3').errors &&
                !bulkAddressForm.get('addressLine3').errors['required'] &&
                !bulkAddressForm.get('addressLine3').valid &&
                bulkAddressForm.get('addressLine3').touched"
              class="help-block has-error validationMessage">
              Please enter a valid Address - only numbers, alpha characters, spaces and dashes are allowed
            </span>
          </div>
        </div>
        <div class="row" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-6 staticText1" style="margin-bottom: 15px;">
            {{shipsContact.emvBulkAddress.addressLine2}}
          </div>
          <div class="form-group col-md-6 staticText1" style="margin-bottom: 15px;">
            {{shipsContact.emvBulkAddress.addressLine3}}
          </div>
        </div>
        <!-- EMV City/State/Zip/Country -->
        <div class="row" *ngIf="hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-3">
            <span class="labelCommon">*City</span><br>
            <input
              type="text"
              class="form-control input-sm"
              id="emvCity"
              formControlName="city"
              maxlength="34"/>
            <span id="spanCity"
              *ngIf="bulkAddressForm.get('city').touched &&
                bulkAddressForm.get('city').errors &&
                bulkAddressForm.get('city').errors['required']"
              class="help-block has-error validationMessage">
              Required
            </span>
            <span
              *ngIf="bulkAddressForm.get('city').errors &&
                !bulkAddressForm.get('city').errors['required'] &&
                !bulkAddressForm.get('city').valid &&
                bulkAddressForm.get('city').touched"
              class="help-block has-error validationMessage">
              Please enter a valid City name - only alpha characters, spaces and dashes are allowed
            </span>
          </div>
          <div class="form-group col-md-3"  *ngIf="isStateShown">
            <span class="labelCommon">*State</span><br>
            <select
              class="form-control input-sm"
              id="emvState"
              formControlName="state">
              <option *ngFor="let state of shipsContact.states"
                      [value]="state">{{state}}</option>
            </select>
            <span
              *ngIf="!bulkAddressForm.get('state').valid &&
                bulkAddressForm.get('state').touched &&
                bulkAddressForm.get('state').errors['required']"
              class="help-block has-error validationMessage">
              Required
            </span>
          </div>
          <div class="form-group col-md-3" *ngIf="!isStateShown">
            <span class="labelCommon">*State</span><br>
            <input
              type="text"
              class="form-control input-sm"
              id="emvStateText"
              formControlName="state"
              maxlength="34"/>
             <span
              *ngIf="!bulkAddressForm.get('state').valid &&
                bulkAddressForm.get('state').touched"
              class="help-block has-error validationMessage">
                <span *ngIf="bulkAddressForm.get('state').errors['required']">
              Required
            </span>
                <span
                  *ngIf="bulkAddressForm.get('state').errors &&
                    !bulkAddressForm.get('state').errors['required']">
                  Please enter a valid State name - only alpha characters, spaces and dashes are allowed
                </span>
            </span>
          </div>
          <div class="form-group col-md-2">
            <span class="labelCommon">*Zip</span><br>
            <input
              type="text"
              class="form-control input-sm"
              id="emvZip"
              formControlName="zip"
              name="emvBulkZip"
              maxlength="10"/>
            <span
              *ngIf="bulkAddressForm.get('zip').touched &&
                     bulkAddressForm.get('zip').errors"
              class="help-block has-error validationMessage">
              <span *ngIf="bulkAddressForm.get('zip').errors['required']">
              Required
            </span>
              <span *ngIf="!bulkAddressForm.get('zip').errors['required'] &&
                           !bulkAddressForm.get('zip').valid">
              Please enter a valid Zip - only numbers are allowed
            </span>
            </span>
          </div>
          <div class="form-group col-md-2">
            <span class="labelCommon">*Country</span><br>
            <select
              class="form-control input-sm"
              id="emvCountry"
              formControlName="country"
              [(ngModel)]="defaultCountry"
              (change)='onCountryChange($event)'>
              <option *ngFor="let country of shipsContact.countries"
                      [value]="country">{{country}}</option>
            </select>
            <span
              *ngIf="!bulkAddressForm.get('country').valid &&
                bulkAddressForm.get('country').touched &&
                bulkAddressForm.get('country').errors['required']"
              class="help-block has-error validationMessage">
              Required
            </span>
          </div>
        </div>
        <div class="row" *ngIf="!hasEntitlement('SHIPS_CONTACTS_UPDATE')">
          <div class="form-group col-md-3">
            <span class="labelCommon">*City</span><br><span
            class="staticText1">{{shipsContact.emvBulkAddress.city}}</span>
          </div>
          <div class="form-group col-md-3">
            <span class="labelCommon">*State</span><br><span
            class="staticText1">{{shipsContact.emvBulkAddress.state}}</span>
          </div>
          <div class="form-group col-md-2">
            <span class="labelCommon">*Zip</span><br><span
            class="staticText1">{{shipsContact.emvBulkAddress.zip}}</span>
          </div>
          <div class="form-group col-md-2">
            <span class="labelCommon">*Country</span><br><span
            class="staticText1">{{shipsContact.emvBulkAddress.country}}</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
